import { useEffect } from "react";
import { Link } from "react-router-dom";

const suggestions = [
  { to: "/leads", label: "线索广场", icon: "ri-map-pin-2-line" },
  { to: "/bounty", label: "悬赏榜", icon: "ri-trophy-line" },
  { to: "/submit", label: "提供线索", icon: "ri-megaphone-line" },
];

export default function NotFound() {
  useEffect(() => {
    document.title = "页面不存在 | 爆料51";
    let robots = document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex, follow");
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 py-20 text-center">
      <span className="flex h-20 w-20 items-center justify-center rounded-lg bg-primary-50 font-heading text-3xl font-bold text-primary-600">
        404
      </span>
      <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">这条线索走丢了</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的页面不存在或已被调整。可以返回首页，或从下面的入口继续浏览正在征集的线索。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        {suggestions.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            <i className={item.icon} />
            {item.label}
          </Link>
        ))}
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
      </div>
    </div>
  );
}